import { computed as h, toValue as U, watch as R, ref as M, provide as Y, inject as j, onMounted as ae, onUnmounted as ne, defineComponent as S, useModel as L, openBlock as q, createBlock as k, unref as l, mergeModels as G, createElementBlock as F, createSlots as T, withCtx as b, renderSlot as f, createTextVNode as g, toDisplayString as y, createCommentVNode as N, normalizeProps as ge, guardReactiveProps as Ve, withDirectives as xe, vShow as $e, Fragment as oe, createVNode as z, createElementVNode as de, normalizeClass as ke } from "vue";
import { useAppI18n as w, useApplicationStore as O, localDate as Z, validatePAN as Ie, reportCustomError as Te, useFieldStore as Fe, reportSessionError as Me, useAppFieldResponse as re, States as Se, Countries as Ce, formatDate as Ae, useSessionStore as we, formatCurrency as Q } from "@versatile-credit-apply/sdk";
import { useOmniApplyApiClient as H, BadRequestException as Ue, ApplicantType as Re } from "@versatile-credit-apply/omni-apply-client";
import { createRule as Be, useRegle as De } from "@regle/core";
import { useI18n as D } from "vue-i18n";
import { useValidationRules as Pe } from "@ui-kit/components";
import { withMessage as B, withAsync as Ee, matchRegex as Le, minValue as Ne, maxValue as ze, withParams as Oe, isEmpty as _ } from "@regle/rules";
import je from "@ui-kit/components/input-checkbox";
import Ke from "@ui-kit/components/input-currency";
import K from "@ui-kit/components/input-dropdown";
import Ye from "@ui-kit/components/input-number";
import Ge from "@ui-kit/components/input-postal-code";
import Ze from "@ui-kit/components/input-ssn";
import ee from "@ui-kit/components/input-text";
import He from "@ui-kit/components/input-phone";
import ue from "@ui-kit/components/input-email";
import We from "@ui-kit/components/input-date";
import se from "@ui-kit/components/select-button";
import Xe from "@ui-kit/components/input-signature-pad";
import { useOptionalFieldController as Je } from "@versatile-credit-apply/composition";
import Qe from "@ui-kit/components/form";
import _e from "@ui-kit/components/modal";
import et from "primevue/inputnumber";
import tt from "@ui-kit/components/error-text";
const te = (e, i) => {
  let t = "";
  return e > 0 && (t += "!*".repeat(e)), i > 0 && (t += "#".repeat(i)), t;
}, it = (e) => e <= 8 ? "!*!*!*!*-####" : e <= 12 ? "!*!*!*!*-!*!*!*!*-####" : e <= 16 ? "!*!*!*!*-!*!*!*!*-!*!*!*!*-####" : "!*!*!*!*-!*!*!*!*-!*!*!*!*-!*!*!*!*-###", lt = (e, i) => {
  if (e === "all")
    return te(i.length, 0);
  if (e === "last4" && i.length > 4)
    return te(i.length - 4, 4);
  if (e === "pan")
    return it(i.length);
}, at = (e, i) => h(() => {
  const t = U(i), n = e.value;
  if (t && typeof n == "string")
    return typeof t == "function" ? t(n) : lt(t, n);
}), nt = (e) => {
  const { t: i, te: t } = w({
    useScope: "parent"
  });
  return h(() => {
    const n = e.value?.id;
    if (t(`appFields.${n}.label`))
      return i(`appFields.${n}.label`);
    const p = `appFields.${e.value?.name}.label`;
    return t(p) ? i(p) : p;
  });
}, ot = (e) => {
  const { t: i, te: t } = w({
    useScope: "parent"
  });
  return h(() => {
    const n = e.value?.name;
    if (t(`appFields.${n}.description`))
      return i(`appFields.${n}.description`);
    const p = `appFields.${e.value?.id}.description`;
    return t(p) ? i(p) : void 0;
  });
}, me = (e) => {
  const i = O(), t = h({
    get() {
      const n = U(e);
      if (n) {
        const d = i.getApplicationValue(n);
        return d === null ? void 0 : d;
      }
    },
    set(n) {
      const d = U(e);
      d && (typeof n == "string" && (n = n.trim()), (n === void 0 || n === "") && (n = null), i.setApplicationValue(d, n));
    }
  });
  return R(
    () => U(e),
    (n, d) => {
      d && n && (t.value = i.getApplicationValue(d), i.setApplicationValue(d, void 0));
    }
  ), t;
}, dt = (e) => e.rules.some((i) => i.id === "disabled") ? !0 : void 0, rt = (e) => {
  if (e.rules.find(({ id: i }) => i === "required"))
    return !0;
}, ut = () => {
  const e = O();
  return (i) => {
    const t = e.getApplicationValue(i.fieldPath);
    switch (i.operation) {
      case "equals":
        return i.fieldValue === t;
      case "not_equals":
        return i.fieldValue !== t;
      case "in":
        return Array.isArray(i.fieldValue) && typeof t == "string" && i.fieldValue.includes(t);
    }
  };
}, st = (e) => {
  const i = ut();
  return h(() => {
    if (!e.value)
      return !1;
    if (rt(e.value))
      return !0;
    const t = e.value.rules.filter(
      ({ id: n }) => n === "requiredIf"
    );
    if (t.length > 0) {
      for (const n of t)
        if (!i(n))
          return;
      return !0;
    }
  });
}, mt = (e) => {
  const i = e.rules.find((t) => t.id === "minLength") || e.rules.find((t) => t.id === "pan");
  if (i?.id === "minLength")
    return i.length;
  if (i?.id === "pan")
    return 8;
}, ct = (e) => {
  const i = e.rules.find((t) => t.id === "maxLength") || e.rules.find((t) => t.id === "pan");
  if (i?.id === "maxLength")
    return i.length;
  if (i?.id === "pan")
    return 19;
}, pt = (e) => {
  const i = e.rules.find((t) => t.id === "validChars") || e.rules.find((t) => t.id === "pan");
  if (i?.id === "validChars") {
    let t = "";
    for (const n of i.validChars)
      n.length === 1 ? t += n.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : t += n;
    return new RegExp(`^[${t}]*$`);
  }
  if (i?.id === "pan")
    return /^\d+$/;
}, vt = (e) => {
  const i = e.rules.find(({ id: t }) => t === "min");
  return i?.id === "min" ? i.value : void 0;
}, ft = (e) => {
  const i = e.rules.find(({ id: t }) => t === "max");
  return i?.id === "max" ? i.value : void 0;
}, bt = (e) => {
  const i = e.rules.find(({ id: t }) => t === "maxAge" || t === "minDate");
  if (i?.id === "maxAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - i.age), t;
  }
  if (i?.id === "minDate")
    return Z(i.value);
}, ht = (e) => {
  const i = e.rules.find(({ id: t }) => t === "minAge" || t === "maxDate");
  if (i?.id === "minAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - i.age), t;
  }
  if (i?.id === "maxDate")
    return Z(i.value);
}, yt = () => {
  const { t: e } = D({ useScope: "global" }), i = H();
  return Be({
    async validator(t) {
      if (t?.length !== 10)
        return !0;
      try {
        return (await i.validatePhone({
          phoneNumber: t
        })).valid;
      } catch {
        return !1;
      }
    },
    message: () => e("validations.phone")
  });
}, qt = (e) => {
  const i = H(), { t } = D({ useScope: "global" });
  return B(
    Ee(async (d, p) => {
      if (p === void 0 || d?.length !== 5 && d?.length !== 9)
        return !0;
      try {
        return {
          $valid: (await i.validateZipCode({
            state: p,
            zipCode: d
          })).valid,
          state: p
        };
      } catch {
        return {
          $valid: !1,
          state: p
        };
      }
    }, [e]),
    ({ state: d }) => t("validations.zipCode", {
      state: d
    })
  );
}, ce = (e, i) => {
  const { t } = D({ useScope: "global" });
  return B(i, () => t(`validations.${e}`));
}, gt = () => ce("pan", (e) => e == null ? !0 : Ie(e)), Vt = /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|\d*)?\b/i, xt = () => ce("noPoBox", (e) => (e?.length ?? 0) > 0 ? !Le(e, Vt) : !0), $t = (e) => {
  const i = O();
  return h(() => {
    if (!e.value)
      return;
    const { path: t, type: n } = e.value;
    if (n !== "zip_code" || t.endsWith(".employerZip"))
      return;
    const d = t.replace(".zipCode", ".state");
    return i.getApplicationValue(d);
  });
}, kt = (e, i) => {
  const t = yt(), n = xt(), d = gt(), p = qt($t(e));
  Pe((u) => {
    if (e.value) {
      const { type: v, rules: c } = e.value, x = {
        // @ts-expect-error this really is a thing: https://reglejs.dev/core-concepts/modifiers#per-field-modifiers
        $debounce: 0
      };
      if (i && Object.assign(x, i(u)), v === "phone" && (x.phone = t), v === "zip_code" && (x.zipCode = p), c.length > 0) {
        const m = (o) => c.some(({ id: I }) => I === o);
        m("noPoBox") && (x.noPoBox = n), m("pan") && (x.pan = d);
      }
      return x;
    }
    return {};
  });
}, pe = (e, i) => {
  kt(e, i);
  const t = st(e);
  return h(() => e.value?.rules?.length ? {
    disabled: dt(e.value),
    required: t.value,
    minLength: mt(e.value),
    maxLength: ct(e.value),
    minValue: vt(e.value),
    maxValue: ft(e.value),
    minDate: bt(e.value),
    maxDate: ht(e.value),
    pattern: pt(e.value)
  } : {});
}, ve = /* @__PURE__ */ Symbol("app-form-state"), fe = /* @__PURE__ */ Symbol("app-form-group-state"), It = () => {
  const e = M({});
  return Y(ve, {
    add(i) {
      e.value[i.id] = i;
    },
    remove(i) {
      delete e.value[i.id];
    }
  }), e;
}, Tt = () => {
  const e = M({});
  return Y(fe, {
    add(i) {
      e.value[i.id] = i;
    },
    remove(i) {
      delete e.value[i.id];
    }
  }), e;
}, Ft = (e) => {
  const i = j(ve, void 0), t = j(fe, void 0);
  R(e, (n, d) => {
    d && (i?.remove(d), t?.remove(d)), n && (i?.add(n), t?.add(n));
  }), ae(() => {
    e.value && (i?.add(e.value), t?.add(e.value));
  }), ne(() => {
    e.value && (i?.remove(e.value), t?.remove(e.value));
  });
}, Mt = (e) => Te("validation_error", e.code, e.field), St = (e, i, t, n) => {
  const d = n && n.length > 0 ? e.error.fieldErrors.filter((u) => n.includes(u.field)) : e.error.fieldErrors;
  if (d.length === 0)
    return !0;
  const p = {};
  return d.forEach((u) => {
    Mt(u);
    const v = u.code.replace("rule.", "");
    p[u.field] = [
      t(`validations.${v}`) ? i(`validations.${v}`, u.params || {}) : u.message
    ];
  }), p;
}, Ct = () => {
  const e = H(), i = O(), t = Fe(), { t: n, te: d } = w({
    useScope: "parent"
  });
  return async (p) => {
    const u = t.fieldProviderKeys;
    try {
      return await e.validateApplication({
        providerKeys: u,
        applicationData: i.application ?? {},
        fieldIds: p
      }), !0;
    } catch (v) {
      if (v instanceof Ue)
        return St(v, n, d, p);
      throw Me(v), v;
    }
  };
}, be = /* @__PURE__ */ Symbol("before-form-submit"), ui = (e) => {
  const i = j(be);
  if (!i)
    throw new Error("BeforeFormSubmit key was not provided");
  return i.onBeforeFormSubmit(e);
}, he = /* @__PURE__ */ S({
  __name: "YesNoInput",
  props: /* @__PURE__ */ G({
    id: {},
    name: {},
    label: {},
    helpText: {},
    required: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const i = L(e, "modelValue"), t = h({
      get() {
        return i.value?.toString();
      },
      set(p) {
        typeof p == "string" ? i.value = p === "true" : i.value = void 0;
      }
    }), { t: n } = D(), d = h(() => [
      {
        value: "true",
        label: n("option.yes.label")
      },
      {
        value: "false",
        label: n("option.no.label")
      }
    ]);
    return (p, u) => (q(), k(l(se), {
      id: e.id,
      modelValue: t.value,
      "onUpdate:modelValue": u[0] || (u[0] = (v) => t.value = v),
      name: e.name ?? e.id,
      options: d.value,
      "option-label": (v) => v.label,
      "option-value": (v) => v.value,
      required: e.required,
      label: e.label,
      "help-text": e.helpText
    }, null, 8, ["id", "modelValue", "name", "options", "option-label", "option-value", "required", "label", "help-text"]));
  }
});
function ie(e) {
  const i = e;
  i.__i18n = i.__i18n || [], i.__i18n.push({
    locale: "en",
    resource: {
      option: {
        no: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
        },
        yes: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } }
        }
      }
    }
  });
}
typeof ie == "function" && ie(he);
const At = (e) => {
  const i = Je(), t = h(() => ({
    id: e.value?.id
  }));
  return i?.attach(t.value), R(t, (n, d) => {
    d && i?.detach(d.id), n && i?.attach(n);
  }), ne(() => {
    i?.detach(t.value?.id);
  }), t;
}, wt = ["id"], Ut = { key: 15 }, Rt = {
  boolean: "checkbox",
  cents: "currency",
  country: "dropdown",
  enum: "dropdown",
  email: "email",
  integer: "number",
  list: "dropdown",
  local_date: "date",
  map: void 0,
  months: "number",
  phone: "phone",
  phone_extension: "phone_extension",
  ssn: "ssn",
  state: "dropdown",
  text: "text",
  years: "number",
  yesNo: "yes-no",
  zip_code: "zip"
}, si = /* @__PURE__ */ S({
  __name: "AppField",
  props: /* @__PURE__ */ G({
    label: {},
    helpText: {},
    path: {},
    pathPrefix: {},
    preferredComponent: {},
    required: { type: Boolean },
    disabled: { type: Boolean },
    inputMask: {},
    privacyMode: { type: [String, Function] },
    optionDisabled: { type: Function },
    displayUnit: {},
    hideRequiredIndicator: { type: Boolean },
    legacyMode: { type: Boolean }
  }, {
    visible: { type: Boolean },
    visibleModifiers: {},
    modelValue: {
      // Value passed here comes from the parent component's v-model binding
    },
    modelModifiers: {}
  }),
  emits: ["update:visible", "update:modelValue"],
  setup(e) {
    const i = e, t = re(
      () => i.pathPrefix ? `${i.pathPrefix}.${i.path}` : i.path
    ), n = L(e, "visible"), d = me(() => t.value?.path), p = M(!0), u = L(e, "modelValue", {
      // Value passed here comes from the parent component's v-model binding
      get(a) {
        const r = d.value;
        return p.value && r != null && a == null ? u.value = r : r !== a && (d.value = a), p.value = !1, d.value;
      },
      set(a) {
        return d.value !== a && (d.value = a), d.value;
      }
    }), v = nt(t), c = h(() => i.label ?? v.value), x = ot(t), m = h(() => i.helpText ?? x.value), o = pe(t), I = w({ useScope: "parent" });
    Ft(t), At(t);
    const V = h(() => {
      if (!t.value?.type)
        return;
      const r = i.preferredComponent ?? Rt[t.value.type];
      return r === "dropdown" && i.preferredComponent !== "dropdown" && C.value.length < 4 ? "selectbutton" : r;
    }), C = h(() => {
      if (t.value?.type === "state" && !t.value?.rules.find(({ id: r }) => r === "validOptions"))
        return Se.map((r) => ({
          value: r.id,
          label: r.name
        }));
      if (t.value?.type === "country")
        return Ce.map((r) => ({
          value: r.id,
          label: r.name
        }));
      const a = t.value?.rules?.find(({ id: r }) => r === "validOptions");
      return a?.id === "validOptions" ? a.options.sort((r, s) => r.order - s.order).map((r) => ({
        value: r.value,
        label: I.te(
          `appFields.${t.value?.id}.option.${r.value}.label`
        ) ? I.t(
          `appFields.${t.value?.id}.option.${r.value}.label`
        ) : r.label
      })) : [];
    }), $ = h({
      get() {
        const a = u.value;
        return typeof a == "string" ? a : void 0;
      },
      set(a) {
        u.value = a;
      }
    }), P = h({
      get() {
        const a = u.value;
        return typeof a == "number" ? a : void 0;
      },
      set(a) {
        u.value = a;
      }
    }), A = h({
      get() {
        const a = u.value;
        return typeof a == "number" || typeof a == "string" ? a : void 0;
      },
      set(a) {
        u.value = a;
      }
    }), E = h({
      get() {
        const a = u.value;
        return typeof a == "boolean" ? a : void 0;
      },
      set(a) {
        u.value = a;
      }
    }), W = h({
      get() {
        const a = u.value;
        return typeof a == "string" ? Z(a) : void 0;
      },
      set(a) {
        a != null ? u.value = Ae(a, "isoDate") : u.value = void 0;
      }
    }), X = h(
      () => t.value?.rules?.find((a) => a.id === "pan") != null
    ), ye = h(() => {
      if (i.inputMask)
        return i.inputMask;
      if (X.value)
        return "9999-9999-9999-9990-000";
    }), J = at(u, () => {
      if (i.privacyMode)
        return i.privacyMode;
      if (X.value)
        return "pan";
    }), qe = h(() => {
      const a = U(t)?.path;
      if (a != null)
        switch (a) {
          case "purchaser.identity.number":
          case "joint.identity.number":
          case "primary.identity.number":
          case "bankAccount.routingNumber":
          case "bankAccount.accountNumber":
            return "numeric";
        }
    });
    return R(
      t,
      (a) => {
        n.value = !!a;
      },
      {
        immediate: !0
      }
    ), R(d, (a) => {
      u.value !== a && (u.value = a);
    }), (a, r) => l(t) ? (q(), F("div", {
      key: 0,
      id: `app-field--${l(t).id}`,
      class: "relative"
    }, [
      V.value === "text" ? (q(), k(l(ee), {
        key: 0,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        "min-length": l(o).minLength,
        "max-length": l(o).maxLength,
        pattern: l(o).pattern,
        disabled: e.disabled || l(o).disabled,
        "privacy-mask": l(J),
        inputmode: qe.value,
        mask: ye.value,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "min-length", "max-length", "pattern", "disabled", "privacy-mask", "inputmode", "mask", "hide-required-indicator"])) : V.value === "signature" ? (q(), k(l(Xe), {
        key: 1,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[1] || (r[1] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, null, 8, ["id", "modelValue", "name", "required", "disabled", "hide-required-indicator"])) : V.value === "ssn" ? (q(), k(l(Ze), {
        key: 2,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[2] || (r[2] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "disabled", "hide-required-indicator"])) : V.value === "number" ? (q(), k(l(Ye), {
        key: 3,
        id: l(t).id,
        modelValue: P.value,
        "onUpdate:modelValue": r[3] || (r[3] = (s) => P.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        "min-value": l(o).minValue,
        "max-value": l(o).maxValue,
        "max-length": l(o).maxLength,
        disabled: e.disabled || l(o).disabled,
        type: "integer",
        "privacy-mask": l(J),
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "min-value", "max-value", "max-length", "disabled", "privacy-mask", "hide-required-indicator"])) : V.value === "currency" ? (q(), k(l(Ke), {
        key: 4,
        id: l(t).id,
        modelValue: P.value,
        "onUpdate:modelValue": r[4] || (r[4] = (s) => P.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        "min-amount-cents": l(o).minValue,
        "max-amount-cents": l(o).maxValue,
        disabled: e.disabled || l(o).disabled,
        "model-unit": "cents",
        "display-unit": e.displayUnit ?? "dollars",
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "min-amount-cents", "max-amount-cents", "disabled", "display-unit", "hide-required-indicator"])) : V.value === "dropdown" ? (q(), k(l(K), {
        key: 5,
        id: l(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[5] || (r[5] = (s) => A.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        options: C.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": l(o).required === void 0,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled", "hide-required-indicator"])) : V.value === "selectbutton" ? (q(), k(l(se), {
        key: 6,
        id: l(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[6] || (r[6] = (s) => A.value = s),
        options: C.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        label: c.value,
        "help-text": m.value,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, null, 8, ["id", "modelValue", "options", "option-label", "option-value", "option-disabled", "required", "disabled", "label", "help-text", "hide-required-indicator"])) : V.value === "zip" ? (q(), k(l(Ge), {
        key: 7,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[7] || (r[7] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "disabled", "hide-required-indicator"])) : V.value === "email" ? (q(), k(l(ue), {
        key: 8,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[8] || (r[8] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        "min-length": l(o).minLength,
        "max-length": l(o).maxLength,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "min-length", "max-length", "disabled", "hide-required-indicator"])) : V.value === "phone" ? (q(), k(l(He), {
        key: 9,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[9] || (r[9] = (s) => $.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "disabled", "hide-required-indicator"])) : V.value === "date" ? (q(), k(l(We), {
        key: 10,
        id: l(t).id,
        modelValue: W.value,
        "onUpdate:modelValue": r[10] || (r[10] = (s) => W.value = s),
        required: e.required || l(o).required,
        "min-date": l(o).minDate,
        "max-date": l(o).maxDate,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "required", "min-date", "max-date", "disabled", "hide-required-indicator"])) : V.value === "checkbox" ? (q(), k(l(je), {
        key: 11,
        id: l(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": r[11] || (r[11] = (s) => E.value = s),
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1,
        "legacy-mode": e.legacyMode ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "required", "disabled", "hide-required-indicator", "legacy-mode"])) : V.value === "yes-no" ? (q(), k(he, {
        key: 12,
        id: l(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": r[12] || (r[12] = (s) => E.value = s),
        name: l(t).id,
        label: c.value,
        "help-text": m.value,
        required: e.required || l(o).required,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "label", "help-text", "required", "disabled", "hide-required-indicator"])) : V.value === "phone_extension" ? (q(), k(l(ee), {
        key: 13,
        id: l(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": r[13] || (r[13] = (s) => $.value = s),
        type: "tel",
        name: l(t).id,
        required: e.required || l(o).required,
        "min-length": 3,
        "max-length": 6,
        pattern: /\d{3,6}/,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, T({
        label: b(() => [
          f(a.$slots, "label", { field: l(t) }, () => [
            g(y(c.value), 1)
          ])
        ]),
        _: 2
      }, [
        a.$slots.helpText || m.value ? {
          name: "helpText",
          fn: b(() => [
            f(a.$slots, "helpText", { field: l(t) }, () => [
              g(y(m.value), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "modelValue", "name", "required", "disabled", "hide-required-indicator"])) : V.value === "country" ? (q(), k(l(K), {
        key: 14,
        id: l(t).id,
        modelValue: A.value,
        "onUpdate:modelValue": r[14] || (r[14] = (s) => A.value = s),
        name: l(t).id,
        required: e.required || l(o).required,
        options: C.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": l(o).required === void 0,
        disabled: e.disabled || l(o).disabled,
        "hide-required-indicator": e.hideRequiredIndicator ?? !1
      }, null, 8, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled", "hide-required-indicator"])) : (q(), F("span", Ut, "Not implemented: " + y(l(t).type), 1)),
      f(a.$slots, "description", { field: l(t) })
    ], 8, wt)) : N("", !0);
  }
}), mi = /* @__PURE__ */ S({
  __name: "AppForm",
  props: {
    id: {},
    submitting: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["submit"],
  setup(e, { emit: i }) {
    const t = i, n = M(!1), d = It(), p = Ct(), u = M(/* @__PURE__ */ new Set());
    function v(o) {
      return u.value.add(o), {
        off: () => {
          u.value.delete(o);
        },
        submit: m
      };
    }
    const c = async () => {
      n.value = !0;
      const o = Object.keys(d.value), I = await p(o);
      for (const V of u.value)
        if (!await V())
          return n.value = !1, {};
      return n.value = !1, I;
    }, x = async () => {
      t("submit");
    }, m = async () => {
      await c() === !0 && await x();
    };
    return Y(be, {
      onBeforeFormSubmit: v
    }), (o, I) => (q(), k(l(Qe), {
      id: e.id,
      disabled: e.disabled || n.value,
      submitting: e.submitting || n.value,
      "before-submit": c,
      class: "flex h-full flex-col",
      onSubmit: x
    }, {
      default: b((V) => [
        f(o.$slots, "default", ge(Ve(V)))
      ]),
      _: 3
    }, 8, ["id", "disabled", "submitting"]));
  }
}), ci = /* @__PURE__ */ S({
  __name: "AppFormGroup",
  setup(e) {
    const i = Tt(), t = h(() => Object.keys(i.value).length > 0);
    return (n, d) => xe((q(), F("div", null, [
      f(n.$slots, "default")
    ], 512)), [
      [$e, t.value]
    ]);
  }
}), Bt = /* @__PURE__ */ S({
  __name: "TestCaseChooser",
  emits: ["selected"],
  setup(e, { emit: i }) {
    const t = we(), { t: n } = w(), d = M(t.testCase?.id), p = M(!1), u = h(() => (t.testCases.length ?? 0) > 0), v = i, c = () => {
      u.value && (p.value = !0);
    }, x = () => {
      const o = d.value, I = o != null ? t.testCases.find((V) => V.id === o) : void 0;
      I && v("selected", I);
    }, m = () => {
      d.value = void 0;
    };
    return (o, I) => {
      const V = K, C = _e;
      return q(), F(oe, null, [
        z(C, {
          modelValue: p.value,
          "onUpdate:modelValue": I[1] || (I[1] = ($) => p.value = $),
          header: "Test Case",
          "cancel-button-label": l(n)("buttons.cancel"),
          "accept-button-label": l(n)("buttons.accept"),
          onModalAccept: x,
          onModalReject: m
        }, {
          default: b(() => [
            z(V, {
              id: "testCases",
              modelValue: d.value,
              "onUpdate:modelValue": I[0] || (I[0] = ($) => d.value = $),
              options: l(t).testCases,
              "option-label": ($) => $.name,
              "option-value": ($) => $.id
            }, null, 8, ["modelValue", "options", "option-label", "option-value"])
          ]),
          _: 1
        }, 8, ["modelValue", "cancel-button-label", "accept-button-label"]),
        de("div", {
          class: ke({
            "cursor-pointer": u.value
          }),
          onClickCapture: c
        }, [
          f(o.$slots, "default")
        ], 34)
      ], 64);
    };
  }
});
function le(e) {
  const i = e;
  i.__i18n = i.__i18n || [], i.__i18n.push({
    locale: "en",
    resource: {
      buttons: {
        accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } },
        cancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } }
      }
    }
  });
}
typeof le == "function" && le(Bt);
const Dt = { class: "flex flex-col gap-2 lg:w-90" }, Pt = ["for"], Et = { key: 0 }, pi = /* @__PURE__ */ S({
  __name: "BoringPaymentCalculatorInput",
  props: /* @__PURE__ */ G({
    id: {},
    currencyMode: { default: "dollars" },
    minValue: { default: void 0 },
    maxValue: { default: void 0 },
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const i = L(e, "modelValue"), t = e, n = h({
      get() {
        if (i.value != null)
          return t.currencyMode === "cents" ? i.value / 100 : i.value;
      },
      set(c) {
        if (c == null) {
          i.value = void 0;
          return;
        }
        t.currencyMode === "cents" ? i.value = c * 100 : i.value = c;
      }
    }), { t: d, te: p } = w({
      useScope: "parent"
    }), u = (c) => p(`validations.${t.id}.${c}`) ? `validations.${t.id}.${c}` : `validations.${c}`, { r$: v } = De(i, () => ({
      maxValue: B(
        ze(() => t.maxValue),
        () => d(u("maxValue"), {
          max: Q(t.maxValue, t.currencyMode)
        })
      ),
      minValue: B(
        Ne(() => t.minValue),
        () => d(u("minValue"), {
          min: Q(t.minValue, t.currencyMode)
        })
      )
    }));
    return ae(() => v.$touch()), (c, x) => (q(), F(oe, null, [
      de("div", Dt, [
        c.$slots.label ? (q(), F("label", {
          key: 0,
          for: e.id,
          class: "text-sm text-surface-600"
        }, [
          f(c.$slots, "label")
        ], 8, Pt)) : N("", !0),
        z(l(et), {
          modelValue: n.value,
          "onUpdate:modelValue": x[0] || (x[0] = (m) => n.value = m),
          "input-id": e.id,
          invalid: l(v).$invalid,
          disabled: e.disabled,
          "input-class": [
            "text-center !text-xl font-semibold",
            {
              "!text-primary-600 ": !l(v).$invalid,
              "!text-danger-600": l(v).$invalid
            }
          ],
          currency: "USD",
          mode: "currency"
        }, null, 8, ["modelValue", "input-id", "invalid", "disabled", "input-class"])
      ]),
      l(v).$errors.length ? (q(), F("p", Et, [
        z(l(tt), {
          id: `paycal-error.${e.id}`,
          class: "relative!",
          "active-error": l(v).$errors[0]
        }, null, 8, ["id", "active-error"])
      ])) : N("", !0)
    ], 64));
  }
}), vi = /* @__PURE__ */ S({
  __name: "ConfirmEmailField",
  props: {
    applicantType: { default: Re.PRIMARY },
    id: { default: void 0 }
  },
  setup(e) {
    const i = e, t = me(() => `${i.applicantType}.email`), n = re(
      () => `${i.applicantType}.email`
    ), d = (x) => `validations.${x}`, { t: p } = D({
      useScope: "parent"
    }), u = h(() => n.value ? {
      ...n.value,
      id: `${i.applicantType}ConfirmEmail`,
      name: `${i.applicantType}ConfirmEmail`
    } : null), v = B(
      Oe(
        (x, m) => _(x) || _(m) ? !0 : x === m,
        [t]
      ),
      () => p(d("emailMatch"))
    ), c = pe(
      u,
      () => ({ emailMatch: v })
    );
    return (x, m) => {
      const o = ue;
      return u.value ? (q(), k(o, {
        key: 0,
        id: u.value.id,
        label: l(p)("appFields.confirmEmail.label"),
        required: l(c).required,
        "min-length": l(c).minLength,
        "max-length": l(c).maxLength,
        disabled: l(c).disabled,
        class: "w-full"
      }, null, 8, ["id", "label", "required", "min-length", "max-length", "disabled"])) : N("", !0);
    };
  }
});
export {
  be as B,
  si as _,
  yt as a,
  mi as b,
  ci as c,
  pi as d,
  vi as e,
  Bt as f,
  ui as g,
  me as u
};
//# sourceMappingURL=index-Cxj4b4du.js.map
